<template>
    <div class="other-services container">
      <h2 class="little-title color-blue toUpperCase f-w-700">Outros serviços disponíveis em nossas lojas</h2>
      <div class="service serv-desktop">
        <div class="flex">
          <div class="v-a-in-middle"><img class="show-desktop img-responsive" src="@/assets/home/icons/Icon-timer.png" alt="Icon-timer"> </div>
          <div><h3 class="color-blue big-title f-w-700">Agendamentos</h3></div>
        </div>
        <div class="container-service">
          <VueSlickCarousel v-bind="settings">
            <div class="service-list bg-color-F2F2F2 flex j-c-center color-blue text-center" v-for="(item, index) in servicesAgendamento" :key="index">
              <span class="f-w-700 flex j-c-center">{{item}}</span>
            </div>            
          </VueSlickCarousel>
        </div>
      </div>
      
      <div class="service serv-desktop">
        <div class="flex">
          <div class="v-a-in-middle"><img class="show-desktop img-responsive"  src="@/assets/home/icons/icon-apps.png" alt="icon-apps">  </div>
          <div><h3 class="color-blue big-title f-w-700">Emissão de Documentos</h3></div>
        </div>
        <div class="container-service">
          <VueSlickCarousel v-bind="settings">
            <div class="service-list bg-color-F2F2F2 flex j-c-center color-blue text-center" v-for="(item, index) in servicesApps" :key="index">
              <span class="f-w-700 flex j-c-center">{{item}}</span>
            </div>            
          </VueSlickCarousel>
        </div>
      </div>

      <div class="service serv-desktop">
        <div class="flex">
          <div class="v-a-in-middle"><img class="show-desktop img-responsive"  src="@/assets/home/icons/icon-billet.png" alt="billet">  </div>
          <div><h3 class="color-blue big-title f-w-700">Segunda Via de Contas</h3></div>
        </div>
        <div class="container-service">
          <VueSlickCarousel v-bind="settings">
            <div class="service-list bg-color-F2F2F2 flex j-c-center color-blue text-center" v-for="(item, index) in servicesBillets" :key="index">
              <span class="f-w-700 flex j-c-center">{{item}}</span>
            </div>            
          </VueSlickCarousel>
        </div>
      </div>

      <div class="service serv-desktop">
        <div class="flex">
          <div class="v-a-in-middle">
            <img class="show-desktop img-responsive" src="@/assets/home/icons/icon-sertificates.png" alt="icon-sertificates">
          </div>
          <div><h3 class="color-blue big-title f-w-700">Dívidas e Multas</h3></div>
        </div>
        <div class="container-service">
          <VueSlickCarousel v-bind="settings">
            <div class="service-list bg-color-F2F2F2 flex j-c-center color-blue text-center" v-for="(item, index) in certificates" :key="index">
              <span class="f-w-700 flex j-c-center">{{item}}</span>
            </div>            
          </VueSlickCarousel>
        </div>
      </div>

      <div class="service">
        <div class="flex">
          <h3 class="color-blue little-title f-w-700 toUpperCase">e muito, muito mais...</h3>
        </div>
        <div class="container-service">
          <VueSlickCarousel v-bind="settings">
            <div class="service-list bg-color-175D93 flex j-c-center color-blue text-center" v-for="(item, index) in servicesMoreMore" :key="index">
              <span class="f-w-700 flex j-c-center color-white">{{item}}</span>
            </div>            
          </VueSlickCarousel>
        </div>
      </div>
      <div class="discoverUnitNearby text-center">
        <a href="" v-scroll-to="'#section_IV'" class="color-orange show-desktop f-w-700">Por que a Ponto Fácil?
          <img class="img-responsive" src="@/assets/home/icons/icon-arrow-to-top.png" alt="icon-arrow-to-top">
        </a>
        <div class="show-mobile flex j-c-center">
          <div>
            <a href="" v-scroll-to="'#section_IV'" class="color-orange f-w-700">Por que a <br> Ponto Fácil?</a>
          </div>
          <div>
            <img class="img-responsive" src="@/assets/home/icons/icon-arrow-to-top.png" alt="icon-arrow-to-top">
          </div>
        </div>
        
      </div>
    </div>
</template>

<style scoped>
.other-services{
  padding: 100px 0 50px 0;
}

h3{
  margin-bottom: 0;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.service-list{
  height: 85px;
  border-radius: 15px;
  border: 5px solid #fff;
}

.service-list span{
  font-size: 15px;
  height: 100%;
}

.container-service{
  margin: 0 45px;
}

.container-service{
  padding: 25px 0;
}

.big-title{
  font-size: 28px;
  margin-left: 25px
}

.little-title{
  margin-left: 25px;
  font-size: 25px;
}

h2{
  margin-bottom: 25px;
}

.service img{
  width: 20px;
}

.bg-color-175D93 a:hover{
  color: #fff;
}

.discoverUnitNearby{
  margin-top: 50px
}

.discoverUnitNearby a img{
  width: 25px!important;
  margin-left: 20px;
}

.discoverUnitNearby span{
  color: #E0A638
}

@media only screen and (max-width: 767px){
  .other-services{
    padding: 75px 0 75px 25px; 
  }

  h2{
    margin: 0 20px 50px 20px!important;
  }

  .serv-desktop h3{
    font-size: 28px!important;
    margin: 0 20px!important;
  }

  .discoverUnitNearby .show-mobile div:nth-child(2){
    margin-left: 10px;
  }


}
</style>


<script>
// import $ from 'jquery'
import VueSlickCarousel from 'vue-slick-carousel' 
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'OtherServices',
  components: { VueSlickCarousel },
  data() {
    return {
      servicesAgendamento:[
        "Vacina Covid 19",
        "Exames Médicos",
        "Receita Federal",
        "Justiça Eleitoral",
        "Defensoria Pública da União",
        "CRAS",
        "Bolsa Família",
        "Alistamento Militar",
        "Boletim de Ocorrência",
        "Cartão de idoso",
        "DAT",
        "Passaporte",
        "Poupa Tempo",
      ],
      servicesApps:[
       "RG",
       "CPF",
       "CNH",
       "Título do Eleitor",
       "Documento de Veículos",
       "Antecedentes Criminais"
      ],
      servicesBillets:[
        "Água",
        "Luz",
        "Gás",
        "Faturas de Cartão",
        "Telefone Celular",
        "Boletos",
        "Convênios",
        "Condomínios",
        "Faculdades"
      ],
      certificates:[
        "Consulta CPF e CNPJ",
        "Consultas de Multas e Débitos de Veículos",
        "Consulta de Pontos da CNH",
        "Consulta de Processos Judiciais"
      ],
      servicesMoreMore:[
        "Cópias",
        "Impressões",
        "Digitalização",     
        "Criar E-mails",
        "Currículos",
        "Cadastros em Vagas",
        "Boletim de Ocorrência",
        "Certidões",
        "Procurações",
        "Declarações",
        "Quitação Eleitoral",
        "Pedido de Aposentadoria",
        "Alteração Bolsa Família"
      ],
      settings:
        {
          "dots": false,
          "infinite": true,
          "autoplay": true,
          "autoplaySpeed": 3000,
          "slidesToShow": 4,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "prevArrow":"<img class='img-responsive a-left control-c prev slick-prev' src='"+this.imgWhite+"'>",
          // "nextArrow":"<img class="img-responsive" class='a-right control-c next slick-next' src='../images/shoe_story/arrow-right.png'>",     
          "responsive": [
            {
              "breakpoint": 1024,
              "settings": {
                "slidesToShow": 3,
                "slidesToScroll": 3,
                "infinite": true,
                "dots": true
              }
            },
            {
              "breakpoint": 600,
              "settings": {
                "slidesToShow": 2,
                "slidesToScroll": 2,
                "initialSlide": 2
              }
            },
            {
              "breakpoint": 480,
              "settings": {
                "slidesToShow": 1,
                "slidesToScroll": 1
              }
            }
          ]
        }
      
    }
  },
  mounted() { 
    
  },
  methods: {
    
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
